<template>
  <click-to-edit
    v-model="scope.row.scale.correction"
    :number-format="{decimals: 2, space:true}"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.correction')"
    placeholder=""
    @input="saveElementPropChange(scope.row, 'scale', {correction:$event})"
  >
  </click-to-edit>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-correction-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },

  methods: {

  }
}

</script>

<style>

</style>
